<template>
  <nav
    class="pagination is-small has-margin-right-20 is-right"
    role="navigation"
    aria-label="pagination"
  >
    <ul class="pagination-list">
      <li>
        <button
          v-if="!table"
          :disabled="value === 1"
          class="pagination-previous mr-3 pointer"
          @click=";(currentPage -= 1), $emit('scroll')"
        >
          {{ $t('Previous') }}
        </button>
        <button
          v-if="table"
          :disabled="value === 1"
          class="has-text-grey is-small is-borderless"
          @click=";(currentPage -= 1), $emit('scroll')"
        >
          <vue-icon-base
            height="18"
            width="18"
            :path="$options.icons[$kc('uni-angle-left')]"
          >
          </vue-icon-base>
        </button>
      </li>
      <li
        v-for="(initialPage, index) in initialPages"
        :key="`initialPage-${index}`"
      >
        <p
          v-if="!table"
          class="outline px-4 mr-2 py-2 tag-border has-text-weight-bold pointer"
          :class="currentPage === initialPage ? 'is-current-grey' : ''"
          aria-label="Goto page 1"
          @click="gotoPage(initialPage), $emit('scroll')"
        >
          {{ initialPage }}
        </p>
        <p
          v-if="table"
          class="ml-2 pointer"
          :class="currentPage === initialPage ? 'has-text-weight-bold' : ''"
          aria-label="Goto page 1"
          @click="gotoPage(initialPage), $emit('scroll')"
        >
          {{ initialPage }}
        </p>
      </li>
      <li v-if="middlePages.length" :class="table ? 'ml-2' : ''">....</li>
      <li
        v-for="(middlePage, index) in middlePages"
        :key="`middlePage-${index}`"
      >
        <p
          v-if="!table"
          class="pagination-link"
          :class="currentPage === middlePage ? 'is-current-grey' : ''"
          aria-label="Goto page 1"
          @click="gotoPage(middlePage), $emit('scroll')"
        >
          {{ middlePage }}
        </p>
        <p
          v-if="table"
          class="pointer"
          :class="currentPage === middlePage ? 'has-text-weight-bold' : ''"
          aria-label="Goto page 1"
          @click="gotoPage(middlePage), $emit('scroll')"
        >
          {{ middlePage }}
        </p>
      </li>
      <li v-if="middlePages.length">....</li>
      <li v-for="(lastPage, index) in lastPages" :key="`lastPage-${index}`">
        <p
          v-if="!table"
          class="pagination-link"
          :class="currentPage === lastPage ? 'is-current-grey' : ''"
          aria-label="Goto page 1"
          @click="gotoPage(lastPage), $emit('scroll')"
        >
          {{ lastPage }}
        </p>
        <p
          v-if="table"
          class="ml-2 pointer"
          :class="currentPage === lastPage ? 'has-text-weight-bold' : ''"
          aria-label="Goto page 1"
          @click="gotoPage(lastPage), $emit('scroll')"
        >
          {{ lastPage }}
        </p>
      </li>
      <li>
        <button
          v-if="!table"
          :disabled="value === totalPages"
          class="pagination-link pointer"
          @click=";(currentPage += 1), $emit('scroll')"
        >
          {{ $t('Next') }}
        </button>
        <button
          v-if="table"
          :disabled="value === totalPages"
          class="has-text-grey is-small is-borderless ml-2"
          @click=";(currentPage += 1), $emit('scroll')"
        >
          <vue-icon-base
            height="18"
            width="18"
            :path="$options.icons[$kc('uni-angle-right')]"
          >
          </vue-icon-base>
        </button>
      </li>
    </ul>
  </nav>
</template>
<script>
import VueIconBase from '@/components/Commons/VueIconBase'
import { uniAngleLeft, uniAngleRight } from '@/helpers/icons'
export default {
  icons: {
    uniAngleLeft,
    uniAngleRight
  },
  components: { VueIconBase },
  props: {
    value: {
      type: Number,
      default: 1
    },
    table: {
      type: Boolean,
      default: false
    },
    collectionName: {
      type: String,
      default: ''
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      currentPage: this.value
    }
  },

  computed: {
    totalPages() {
      const pageCount = this.$store.state.collection.collectionResponses[
        this.collectionName
      ]
        ? this.$store.state.collection.collectionResponses[this.collectionName]
            .count
        : 1
      return pageCount ? Math.ceil(pageCount / this.pageSize) : 1
    },

    pages() {
      return Array(this.totalPages)
        .fill(0)
        .map((e, i) => i + 1)
    },
    initialPages() {
      return this.pages.slice(0, 3)
    },
    middlePages() {
      if (this.totalPages > 6) {
        const middlePages = this.pages.slice(3, this.totalPages - 3)
        const currentPageIndex = middlePages.indexOf(this.currentPage)
        let currentPageIsFirst = false
        let currentPageIsLast = false
        if (currentPageIndex === 0) {
          currentPageIsFirst = true
        }

        if (currentPageIndex === middlePages.length - 1) {
          currentPageIsLast = true
        }

        if (currentPageIsFirst) {
          return middlePages.slice(currentPageIndex, currentPageIndex + 2)
        } else if (currentPageIsLast) {
          return middlePages.slice(-2)
        } else {
          return middlePages.slice(currentPageIndex - 1, currentPageIndex + 2)
        }
      } else {
        return []
      }
    },
    lastPages() {
      if (this.totalPages <= 6 && this.totalPages > 3) {
        return this.pages.slice(3)
      } else if (this.totalPages > 6) {
        return this.pages.slice(-3)
      } else {
        return []
      }
    }
  },
  watch: {
    currentPage(val) {
      this.$emit('input', val)
    },
    value() {
      this.currentPage = this.value
    }
  },
  methods: {
    gotoPage(page) {
      this.currentPage = page
    }
  }
}
</script>
